import React from 'react'

import { ExplicitChangeTextInput } from '../../../common/components/explicit-change-text-input'
import { usePageEditorContext } from '../../contexts/page-editor.context'
import { Accordion, AccordionSummary, AccordionDetails } from '../../editor/sidebar-accordion'
import { ManualBlockEditor } from '../../editor/manual-block-editor'
import { HeaderEditAccordion } from '../header-edit-accordion'
import { FooterEditAccordion } from '../footer-edit-accordion'
import { SplitChartFilterEditAccordion } from '../split-chart-filter-edit-accordion'
import { reportDataSetService } from '../../editor/report-data-set.service'
import { FilterEditAccordion } from '../filter-edit-accordion'

export const ForestBlockEditSidebar = function ({ block }) {
  const pageEditorContext = usePageEditorContext() || {}

  const filterOptionLabels = reportDataSetService.getFilterOptionLabels(block)

  function updateBlock (block) {
    pageEditorContext.registerUnsavedChanges()
    pageEditorContext.updateCurrentEdit({ block: { ...block } })
  }

  function getBlockProp (prop, defaultValue) {
    if (block.props[prop] === undefined) {
      return defaultValue
    } else {
      return block.props[prop]
    }
  }

  function setBlockProp (prop, value) {
    block.props[prop] = value
    updateBlock(block)
  }

  function getAxisLabels (prop) {
    const labels = getBlockProp('axisLabels', {})
    if (prop) {
      return labels[prop]
    }
    return labels
  }

  function setAxisLabels (prop, value) {
    const axisLabels = getAxisLabels()
    axisLabels[prop] = value
    setBlockProp('axisLabels', { ...axisLabels })
  }

  function getDomainValues (prop, index) {
    let domainValues = getBlockProp(prop, []) || []
    if (index !== undefined) {
      return isEmpty(domainValues[index]) ? '' : domainValues[index].toString()
    }
    return domainValues
  }

  function setDomainValues (prop, index, value) {
    if (!isEmpty(value) && (prop === 'xValueDomain')) {
      value = parseFloat(value)
    }

    let valueDomain = getDomainValues(prop)
    valueDomain[index] = value
    if (isEmpty(valueDomain[0]) && isEmpty(valueDomain[1])) {
      valueDomain = undefined
    } else if (isEmpty(valueDomain[0])) {
      valueDomain = [null, valueDomain[1]]
    } else if (isEmpty(valueDomain[1])) {
      valueDomain = [valueDomain[0]]
    }
    setBlockProp(prop, [ ...valueDomain ])
  }

  function isEmpty (value) {
    return value === undefined || value === null || value === ''
  }

  return <div className="report-editor-sidebar">
    <Accordion square defaultExpanded={true}>
      <AccordionSummary>
        X Axis
      </AccordionSummary>
      <AccordionDetails>
        <div className="field-grid">
          <div className="full-width-field" data-qa="full-width-field-x-axis">
            <ExplicitChangeTextInput
              size="medium"
              label="X Axis Label"
              value={getAxisLabels('x')}
              onChange={(event) => {
                setAxisLabels('x', event.target.value)
              }}
            />
          </div>
          {[
            ['xValueDomain', 'X Axis Min', 0],
            ['xValueDomain', 'X Axis Max', 1]
          ].map(([prop, label, domainIndex]) => (
            <div key={`${prop}-${domainIndex}`} className="field" data-qa={ `field-${label}`}>
              <ExplicitChangeTextInput
                size="medium"
                label={label}
                value={getDomainValues(prop, domainIndex)}
                onChange={(event) => {
                  setDomainValues(prop, domainIndex, event.target.value)
                }}
              />
            </div>
          ))}

        </div>
      </AccordionDetails>
    </Accordion>
    <SplitChartFilterEditAccordion block={block} />
    <Accordion square>
      <div data-qa='accordion-summary-tooltip'>
        <AccordionSummary>
          Tooltip
        </AccordionSummary>
      </div>
      <AccordionDetails>
        <div className="field-grid">
          <div className="full-width-field" data-qa="group-label">
            <ExplicitChangeTextInput
              size="medium"
              label="Group Label"
              value={getBlockProp('groupLabel')}
              onChange={(event) => {
                setBlockProp('groupLabel', event.target.value)
              }}
            />
          </div>
        </div>
      </AccordionDetails>
    </Accordion>
    <Accordion square>
      <div data-qa='accordion-summary-marker'>
        <AccordionSummary>
          Marker
        </AccordionSummary>
      </div>
      <AccordionDetails>
        <div className="field-grid">
          <div className="full-width-field" data-qa="vertical-null-effect-line">
            <ExplicitChangeTextInput
              size="medium"
              label="Vertical Null Effect Line"
              value={getBlockProp('xValueNullEffectLine')}
              onChange={(event) => {
                setBlockProp('xValueNullEffectLine', event.target.value)
              }}
            />
          </div>
        </div>
      </AccordionDetails>
    </Accordion>
    {filterOptionLabels.filter(({ values, isSplitChartFilter }) => !isSplitChartFilter && values.length > 0).length > 0 && (
      <FilterEditAccordion block={block} />
    )}
    <HeaderEditAccordion block={block} />
    <FooterEditAccordion block={block} />
    <Accordion square>
      <div data-qa='accordion-summary-other'>
        <AccordionSummary>
        Other
        </AccordionSummary>
      </div>
      <AccordionDetails>
        <div className="field-grid">
          <div className="full-width-field">
            <ManualBlockEditor block={block} onChange={updateBlock} />
          </div>
        </div>
      </AccordionDetails>
    </Accordion>
  </div>
}
